import React, { Dispatch, SetStateAction, createContext } from "react";
import { Tablenodatafound } from "../TableNoDataFount";
import CommonArows from "../../CommonArows";
import {
  KWHText,
  MomentDateTime,
  WattText,
  getSeconds,
  getValidData,
} from "../../../Shared/Methods";
import Commontooltip from "../../CommonTooltip/Commontooltip";
import yellodownarrow from "../../../Assests/Images/yellowuparrow.svg";
import yellouparrow from "../../../Assests/Images/yellowdownarrow.svg";
import blackarrowdown from "../../../Assests/Icons/down_arrow_black.png";
import DateHeader from "./ReadingreportsheaderStyle/DateHeaderStyle";
import PinOneHeaderStyle from "./ReadingreportsheaderStyle/PinOneHeaderStyle";
import DateHeaderStyle from "./ReadingreportsheaderStyle/DateHeaderStyle";
import PinTwoHeaderStyle from "./ReadingreportsheaderStyle/PinTwoHeaderStyle";
import PinThreeHeaderStyle from "./ReadingreportsheaderStyle/PinThreeHeaderStyle";

interface props {
  deviceList: any;
  pageSize: number;
  pageind: number;
  GetList: (
    page?: number,
    size?: number,
    values?: any,
    isreset?: boolean,
    isDownload?: boolean,
    OrderBy?: string,
    Order?: string,
    // eb_power?: boolean,
    // dg_power?: boolean,

    pin_1_status?: boolean,
    pin_2_status?: boolean,
    pin_3_status?: boolean,
    // sump_status?: boolean,
    // borewell?: boolean,
    isAlert?: boolean,
    isTime?: boolean,
    communicationfailvalue?: boolean
  ) => void;

  setIsChecked: Dispatch<SetStateAction<any>>;
  SetCheckedArray: Dispatch<SetStateAction<any>>;
  isChecked: any;
  CheckedArray?: any;
  isAlert?: boolean | any;
  AlphabetType?: any;
  isTime: boolean;
  Values: any;
  ChangeOrderType: (OrderBy: string, Order: string) => any;
  OBJKeys: string[];
  communicationfailvalue: boolean;
}

export const ReadingReportContrext = createContext<props | null>(null);

function ReadingReportsTable({
  deviceList,
  pageSize,
  pageind,
  GetList,
  setIsChecked,
  SetCheckedArray,
  isChecked,
  CheckedArray,
  isAlert,
  AlphabetType,
  isTime,
  Values,
  ChangeOrderType,
  OBJKeys,
  communicationfailvalue,
}: props) {
  const { items } = deviceList;

  const Columns = new Array(6).fill({
    avg: "Total",
    r: "R",
    y: "Y",
    b: "B",
  });

  return (
    <>
      <tr>
        <th rowSpan={2}>S.No</th>

        <ReadingReportContrext.Provider
          value={{
            deviceList: deviceList,
            pageSize: pageSize,
            pageind: pageind,
            GetList: GetList,
            setIsChecked: setIsChecked,
            SetCheckedArray: SetCheckedArray,
            isChecked: isChecked,
            CheckedArray: CheckedArray,
            isAlert: isAlert,
            AlphabetType: AlphabetType,
            isTime: isTime,
            Values: Values,
            ChangeOrderType: ChangeOrderType,
            OBJKeys: OBJKeys,
            communicationfailvalue: communicationfailvalue,
          }}
        >
          <DateHeaderStyle />
          <PinOneHeaderStyle />
          <PinTwoHeaderStyle />
          <PinThreeHeaderStyle />
        </ReadingReportContrext.Provider>

        <th rowSpan={2}>Received{KWHText}</th>
        <th rowSpan={2}>Consumed{KWHText}</th>
        <th rowSpan={2}>PF Alert</th>
        <th rowSpan={2}>LV Alert</th>
        <th rowSpan={2}>HV Alert</th>
        <th colSpan={4}>Watts{WattText}</th>
        <th colSpan={4}>VA</th>
        <th colSpan={4}>LN Volts</th>
        <th colSpan={4}>LL Volts</th>
        <th colSpan={4}>Amps</th>
        <th colSpan={4}>PF</th>
        <th rowSpan={2}>Failure Duration</th>
      </tr>

      <tr style={{ position: "sticky", top: "44px" }}>
        {Columns?.map((ele: any, ind: any) => {
          return (
            <>
              {ind === 3 ? (
                <>
                  <th>{ele?.avg}</th>
                  <th>{ele?.r}Y</th>
                  <th>{ele?.y}B</th>
                  <th>{ele?.b}R</th>
                </>
              ) : (
                <>
                  {" "}
                  <th>{ele?.avg}</th>
                  <th>{ele?.r}</th>
                  <th>{ele?.y}</th>
                  <th>{ele?.b}</th>
                </>
              )}
            </>
          );
        })}
      </tr>

      {items?.length > 0 ? (
        items.map((ele: any, ind: number) => {
          return (
            <>
              <tr>
                <td style={{ width: 50 }}>{pageind * pageSize + (ind + 1)}</td>
                {OBJKeys?.map((val: any, ind: number) => {
                  return (
                    <>
                      <td className="transperent_p_tag">
                        {val === "created_at" ? (
                          getValidData(
                            ele?.[val] ? MomentDateTime(ele?.[val]) : ""
                          )
                        ) : val === "pin_1_status" ? (
                          ele?.[val] === 1 ? (
                            <p>On</p>
                          ) : (
                            <p>Off</p>
                          )
                        ) : val === "pin_2_status" ? (
                          ele?.[val] === 1 ? (
                            <p>On</p>
                          ) : (
                            <p>Off</p>
                          )
                        ) : val === "pin_3_status" ? (
                          ele?.[val] === 1 ? (
                            <p>On</p>
                          ) : (
                            <p>Off</p>
                          )
                        ) : val === "pf_alert" ? (
                          ele?.[val] === 1 ? (
                            <p>Yes</p>
                          ) : (
                            <p>No</p>
                          )
                        ) : val === "lv_alert" ? (
                          ele?.[val] === 1 ? (
                            <p>Yes</p>
                          ) : (
                            <p>No</p>
                          )
                        ) : val === "hv_alert" ? (
                          ele?.[val] === 1 ? (
                            <p>Yes</p>
                          ) : (
                            <p>No</p>
                          )
                        ) : val === "failure_duration" ? (
                          <p style={{ background: "transparent", padding: 0 }}>
                            {ele?.[val] ? getSeconds(ele?.[val]) : "-"}
                          </p>
                        ) : (
                          getValidData(ele?.[val])
                        )}
                      </td>
                    </>
                  );
                })}
              </tr>
            </>
          );
        })
      ) : (
        <Tablenodatafound />
      )}
    </>
  );
}

export default ReadingReportsTable;
